
export function tabBarExpand(depth, moreButton) {
	moreButton.hide();
	const rowClass = depth == 1 ? ".tabs-primary" : (depth == 2 ? ".tabs-secondary" : "#"+depth);
	$(rowClass+' .tab-collapsed').fadeIn();
}

window.tabBarExpand = tabBarExpand;

function changeIconColor(element, color) {
	element.find("img").each(function() {
		const img = $(this);
		let src = img.attr("src");
		let newCol = "c="+color;
		src = src.replace(/c=[0-9a-f]{6}/i, newCol);
		img.attr("src", src);
	});
}

export function changeByVar(tab, variable) {
	let color = getComputedStyle(tab.get(0)).getPropertyValue(variable).trim();
	if (color.startsWith("#")) color = color.substring(1);
	changeIconColor(tab, color);
}

export function initTabs(root) {
	const enter = function() {
		changeByVar($(this), "--link-fg-hover");
	};
	const leave = function() {
		changeByVar($(this), "--link-fg");
	};
	root.find(".tab").on("mouseenter", enter).on("mouseleave", leave);
	root.find(".tab-action").on("mouseenter", enter).on("mouseleave", leave).on("click", function() {
		let moreButton = $(this);
		tabBarExpand(moreButton.attr("data-depth"), moreButton);
	});
}

/**
 * @param {string} selector - jQuery selector to obtain A.tab elements
 * @param {string} [defaultTabName] - name of the default tab if url hash is not present
 */
export function initFormNavigation(selector, defaultTabName) {
	const links = $(selector);
	if (links.length > 0) {
		links.on("click", function() {
			const currentTabName = links.filter(function() { return $(this).hasClass("tab-active");}).attr("href").substring(1); //is not same result links.find(".tab-active");
			links.removeClass("tab-active");
			$(this).addClass("tab-active").removeClass("tab-collapsed");
			hideTabBody(currentTabName);
			const id = $(this).attr("href").substring(1);
			changeHash(id);
			showTabBody(id);
			return false;
		});
		let idToOpen;
		if (window.location.hash) {
			idToOpen = window.location.hash.substring(1);
		} else {
			if (defaultTabName) idToOpen = defaultTabName;
			else {
				const first = links.first();
				idToOpen = first.attr("href").substring(1);
			}
			//changeHash(idToOpen);
		}
		let activeTabs = links.filter(function() { return $(this).attr("href") === "#"+idToOpen });
		activeTabs.addClass("tab-active").removeClass("tab-collapsed");
		activeTabs.each(function() { changeByVar($(this), "--link-fg") });
		showTabBody(idToOpen);
	}
}

function showTabBody(id) {
	$("#"+id).addClass("shown");
}

function hideTabBody(id) {
	$("#"+id).removeClass("shown");
}

function changeHash(hash) {
	if (hash) {
		if (window.history) {
			window.history.replaceState(null, null, "#"+hash);
		} else window.location.hash = hash;
	}
}